import React, { useState } from 'react';
import { entityMetaMapping } from 'js/constants';

function searchForFiles(notifications, id, mDate, downloadableFiles = { preview: null, master: null, a11y: null }, docIdentifier = entityMetaMapping.edition) {

  const mDateObj = new Date(mDate);
  const mDateUtc = new Date(Date.UTC(
    mDateObj.getUTCFullYear(),
    mDateObj.getUTCMonth(),
    mDateObj.getUTCDate(),
    mDateObj.getUTCHours(),
    mDateObj.getUTCMinutes(),
    mDateObj.getUTCSeconds(),
    mDateObj.getUTCMilliseconds()
  ));


  for (const notification of notifications) {
    const currentDocIdentifier = notification?.entity_doc_identifier || notification?.entityDocIdentifier;
    if (!notification.metadata || !notification.metadata.quality || currentDocIdentifier !== docIdentifier) {
      continue;
    }

    const notificationQuality = notification.metadata.quality;

    if (!['Preview', 'Master', 'A11y'].includes(notificationQuality)) {
      continue;
    }

    let equalsId = notification?.entityId || notification?.entity_id;

    if (docIdentifier === entityMetaMapping.orderItem) {
      equalsId = notification?.metadata?.parentEntityId || notification?.metadata.parent_entity_id;
    }

    if (equalsId === id) {
      let actualDateToCompareUtc = null;
      let isDateFromUrl = false;

      if (notification.metadata.editionMDate) {
        console.log("actualDateToCompareUtc (from editionMDate)");
        const editionMDate = new Date(notification.metadata.editionMDate);
        actualDateToCompareUtc = new Date(Date.UTC(
          editionMDate.getUTCFullYear(),
          editionMDate.getUTCMonth(),
          editionMDate.getUTCDate(),
          editionMDate.getUTCHours(),
          editionMDate.getUTCMinutes(),
          editionMDate.getUTCSeconds(),
          editionMDate.getUTCMilliseconds()
        ));

      } else if (notification.metadata.printJobUploads && notification.metadata.printJobUploads.length > 0) {
        const uploadUrl = notification.metadata.printJobUploads[0];
        const match = uploadUrl.match(/\/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})[a-zA-Z0-9-]+\.pdf$/);

        if (match) {
          const year = parseInt(match[1], 10);
          const month = parseInt(match[2], 10);
          const day = parseInt(match[3], 10);
          const hour = parseInt(match[4], 10);
          const minute = parseInt(match[5], 10);
          const second = parseInt(match[6], 10);

          actualDateToCompareUtc = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
          isDateFromUrl = true;
          console.log("actualDateToCompareUtc (from URL)");
        }
      }

      if (actualDateToCompareUtc) {
        if (actualDateToCompareUtc.getTime() === mDateUtc.getTime()) {
          const key = notificationQuality.toLowerCase();
          downloadableFiles[key] = notification?.metadata?.printJobUploads;
        }
      }
    }
  }

  return downloadableFiles;
}

export default searchForFiles;
